import axiosInstance from "@/axios/axiosInstance";
import {
  LoginCredentials,
  Resend2FACredentials,
  ResetPasswordCredentials,
  Verify2FACredentials,
} from "@/interface/auth.types";

export const loginUser = async (data: LoginCredentials) => {
  try {
    const payload = {
      email: data.username,
      password: data.password,
      remember: true,
    };
    const response = await axiosInstance.post(`/login`, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (data: ResetPasswordCredentials) => {
  try {
    const payload = {
      token: data.token,
      password: data.password,
      confirm_password: data.confirm_password,
    };
    const response = await axiosInstance.put(`/reset-password`, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const verify2FA = async (data: Verify2FACredentials) => {
  try {
    const payload = {
      email: data.email,
      otp: data.otp,
      remember: true,
    };
    const response = await axiosInstance.post(`/auth/2fa/verify`, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const resend2FA = async (data: Resend2FACredentials) => {
  try {
    const payload = {
      email: data.email,
    };
    const response = await axiosInstance.post(`/auth/2fa/resend`, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
